module.exports = __webpack_public_path__ + "static/media/rsm-back-blue.3253d28f.svg";